export enum MenuItemType {
  Button = 'button',
  Command = 'command',
}

export enum SubKeyboardType {
  Numbers = 'numbers',
  Booleans = 'boolean',
  Hours = 'hours',
}

export enum MenuItemStyle {
  Primary = 'primary',
  Success = 'success',
  Danger = 'danger',
}

export const MenuItemStyleOptions = [
  { label: 'Default', value: null },
  { label: 'Primary (blue)', value: MenuItemStyle.Primary },
  { label: 'Success (green)', value: MenuItemStyle.Success },
  { label: 'Danger (red)', value: MenuItemStyle.Danger },
];

export const MenuItemStyleValues = MenuItemStyleOptions.map(({ value }) => value);

export const MenuItemStyleLabels: Record<MenuItemStyle, string> = {
  [MenuItemStyle.Primary]: 'Primary (blue)',
  [MenuItemStyle.Success]: 'Success (green)',
  [MenuItemStyle.Danger]: 'Danger (red)',
};

export const SubKeyboardTypeLabels: Record<SubKeyboardType, string> = {
  [SubKeyboardType.Numbers]: 'Numbers',
  [SubKeyboardType.Booleans]: 'Yes/No',
  [SubKeyboardType.Hours]: 'Hours',
};
